import ApiService from "@/core/services/api.service";
import AlertService from "@/core/services/alert.service";

// action types

export const PAGINATE_ALL_PASSWORD_RESETS = "getPaginatedPasswordResets";
export const ALL_PASSWORD_RESETS = "getAllPasswordResets";
export const CREATE_PASSWORD_RESET_FORM = "createPasswordResetForm";
export const DELETE_PASSWORD_RESET = "deletePasswordReset";
export const GET_PASSWORD_RESET_DATA = "getPasswordResetData";
export const CREATE_PASSWORD_RESET = "createPasswordReset";
export const UPDATE_PASSWORD_RESET = "updatePasswordReset";
export const SEND_RESET_LINK = "sendResetLinkEmail";
export const PASSWORD_RESET = "passwordReset";

// mutation types

export const SET_PAGINATED_PASSWORD_RESETS = "setPaginatedPasswordResets";
export const SET_ALL_PASSWORD_RESETS = "setAllPasswordResets";
export const SET_PASSWORD_RESET_DATA = "setPasswordResetData";
export const SET_PASSWORD_RESET_META = "setPasswordResetMeta";
export const SET_PASSWORD_RESET_ERROR = "setPasswordResetError";
export const SET_PASSWORD_RESET_LOADING = "setPasswordResetLoading";
export const CLEAR_PASSWORD_RESET_ERROR = "clearPasswordResetError";
export const SET_IS_DISABLED_PASSWORD_RESET = "setIsDisabledPasswordReset";


const state = {
    password_resets: [],
    paginatedPasswordResets: [],
    password_reset_data: {},
    meta_password_reset : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllPasswordResets(state) {
        return state.paginatedPasswordResets;
    },

    allPasswordResets(state) {
        return state.password_resets;
    },

    getPasswordResetData(state) {
        return state.password_reset_data;
    },

    meta_password_reset(state) {
        return state.meta_password_reset;
    },
    
};

const actions = {
 
       [SEND_RESET_LINK](context, payload) {
        context.commit(SET_PASSWORD_RESET_LOADING, false);
        context.commit(SET_IS_DISABLED_PASSWORD_RESET, true);
        context.commit(CLEAR_PASSWORD_RESET_ERROR);
        return ApiService.post("/password/email", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PASSWORD_RESET_ERROR);
            }
            else{
                context.commit(SET_PASSWORD_RESET_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Gönderim Başarılı",
                    "Şifrenizi sıfırlamanız için e-posta adresinizi kontrol edin. E-posta başarılı bir şekilde gönderilmiştir."
                );
                context.commit(CLEAR_PASSWORD_RESET_ERROR);
                context.commit(SET_IS_DISABLED_PASSWORD_RESET, false);
                
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PASSWORD_RESET_LOADING, false);
            context.commit(SET_PASSWORD_RESET_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSWORD_RESET, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                response.data.message
            );
        });
    },

    [PASSWORD_RESET](context, payload) {
        context.commit(SET_PASSWORD_RESET_LOADING, false);
        context.commit(SET_IS_DISABLED_PASSWORD_RESET, true);
        context.commit(CLEAR_PASSWORD_RESET_ERROR);
        return ApiService.post("/password/reset", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PASSWORD_RESET_ERROR);
            }
            else{
                context.commit(SET_PASSWORD_RESET_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Tribün başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_PASSWORD_RESET_ERROR);
                context.commit(SET_IS_DISABLED_PASSWORD_RESET, false);
                
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PASSWORD_RESET_LOADING, false);
            context.commit(SET_PASSWORD_RESET_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSWORD_RESET, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },
    

    
    
};

const mutations = {

    [SET_PAGINATED_PASSWORD_RESETS](state, paginatedPasswordResets) {
        state.paginatedPasswordResets = paginatedPasswordResets.data;
    },

    [SET_ALL_PASSWORD_RESETS](state, password_resets) {
        state.password_resets = password_resets;
    },

    [SET_PASSWORD_RESET_DATA](state, password_resets_data) {
        state.password_resets_data = password_resets_data;
        state.errors = [];
    },

    [SET_PASSWORD_RESET_META](state, meta_password_reset) {
        state.meta_password_reset = meta_password_reset;
    },

    [SET_PASSWORD_RESET_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PASSWORD_RESET_ERROR](state) {
        state.errors = [];
    },
    
    [SET_PASSWORD_RESET_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_PASSWORD_RESET](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
